import axios from 'axios';
import './App.css';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

function VoucherActivation() {
    const navigate = useNavigate();
    const [voucherCode, setVoucherCode] = useState(null);

    function activateVoucher(voucher_code) {
        axios.post(
            process.env.REACT_APP_API_HOST + '/voucher/activation/',
            {
                voucher_code: voucher_code,
            },
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                navigate('/account/');
            }
        ).catch(
            (error) => {

            }
        )
    }

    return (
        <div>
            <Header />
            <div className='standard-box3'>
                <h3>
                    Activate Voucher
                </h3>
            </div>
            <div className='standard-box3'>
                <div>
                    Enter the voucher code here:
                </div>
                <InputText
                    value={voucherCode}
                    onChange={(e) => setVoucherCode(e.target.value)}
                    placeholder='enter voucher code'
                    className='text-input1'
                    style={{ marginTop: '1em' }}
                />
            </div>
            <div
                className="standard-box3"
                align='left'
                style={{ width: '90%' }}
            >
                <Button
                    label="Cancel"
                    severity="secondary"
                    onClick={
                        () => {
                            navigate('/account/');
                        }
                    }
                    size='small'
                />
                <Button
                    label="Activate"
                    severity="success"
                    onClick={() => activateVoucher(voucherCode)}
                    style={{ marginLeft: '0.5em' }}
                    size='small'
                    disabled={voucherCode == '' || voucherCode == null}
                />
            </div>
        </div>
    );
}

export default VoucherActivation;